import React from "react"
import { useState } from "react"
import { useHistory } from "react-router-dom"
import { useCart } from "react-use-cart"
import CartDescription from "../../pages/cart/CartDescription"
import CustomAmountInput from "../CustomerRegistryComponents/CustomAmountInput"
import ModalContainer from "../ModalContainer/ModalContainer"

const ContributionPreview = ({ contribution, progress }) => {
  const { name, target, images, description, _id } = contribution
  const price = parseInt(target - progress)
  const [customAmount, setCustomAmount] = useState(false)
  const history = useHistory()
  const { emptyCart, addItem } = useCart()

  return (
    <div className="mobiles:text-center">
      {customAmount && (
        <CustomAmountInput
          closeModal={() => setCustomAmount(false)}
          handleSuccess={() => {
            history.push("/partial-checkout")
          }}
          maxAmount={price}
        />
      )}

      <img
        style={{ objectFit: "cover" }}
        src={images[0] || ""}
        className="w-full h-60 mobiles:h-28 rounded-tr-md rounded-tl-md block"
        alt=""
      />
      <div className="px-3 border border-gray-200 mobiles:border-transparent mobiles:pb-3 py-2">
        <p className="font-semibold">{`${name}`}</p>
        <p className="text-gray-600 mobiles:text-xs text-sm mt-2 truncate">
          {`${description}`}
        </p>
        <p className="mt-2 mobiles:hidden">
          ₦{`${parseInt(price).toLocaleString("en-NG")}`}
        </p>
        <div className="items-center hidden mobiles:flex justify-center mt-4">
          {/* <button className="rounded px-1 hidden mr-3 items-center  mobiles:flex py-2 text-center ">
            <img
              src={require("../../assets/love-icon.svg").default}
              className="w-4 mr-1"
              alt="love"
            />
            {/* <span style={{ fontSize: "11px" }}>{quantity}</span>
          </button> */}
          <p className="ml-3 text-xs">
            ₦{`${parseInt(price).toLocaleString("en-NG")}`}
          </p>
        </div>
      </div>
      <div className="grid mobiles:justify-center grid-cols-1 mobiles:grid-cols-1">
        {/* <button className="bg-gray-200 px-3 flex items-center justify-center mobiles:hidden py-3 w-full text-center rounded-bl-md">
          <img
            src={require("../../assets/love-icon.svg").default}
            className="w-4 mr-3"
            alt=""
          />
          {/* <span style={{ fontSize: "11px" }}>{quantity}</span>
        </button>
         */}
        <button
          style={{ backgroundColor: "#6F64F8" }}
          className="px-3 py-3 w-full  text-center flex items-center justify-center mobiles:hidden rounded-br-md"
          onClick={() => {
            emptyCart()
            addItem({
              id: _id,
              price: price,
              sales_price: price,
              ...contribution
            })
            setCustomAmount(true)
          }}
        >
          <img
            src={require("../../assets/shopping-bag.svg").default}
            className="w-4 mr-3"
            alt=""
          />
          <span style={{ fontSize: "11px" }} className="text-white">
            CONTRIBUTE
          </span>
        </button>
        <button
          style={{ backgroundColor: "#6F64F8" }}
          className="px-3 mobiles:py-2 py-3 w-full mobiles:w-auto hidden text-center mobiles:flex items-center justify-center mobiles:rounded rounded-br-md"
          onClick={() => {
            emptyCart()
            addItem({
              id: _id,
              price: price,
              sales_price: price,
              ...contribution
            })
            setCustomAmount(true)
          }}
        >
          <img
            src={require("../../assets/shopping-bag.svg").default}
            className="w-4 mr-3"
            alt=""
          />
          <span style={{ fontSize: "9px" }} className="text-white">
            CONTRIBUTE
          </span>
        </button>
      </div>
    </div>
  )
}

export default ContributionPreview
